export default {"src":"/_next/static/media/icon_chat_mute.e55b7822.svg","height":17,"width":14,"blurWidth":0,"blurHeight":0};